import { useState, useEffect } from "react";

import ModalWindow from "../ui/ModalWindow";
import Locker from "../ui/ScreenLocker";

import { saveThemeCookie } from "../lib/manageCookies";

interface PhotosProps extends MobileMode, OrientationMode, ThemeProps {}

const Photos = ({ isMobile, isVertical, isDark, setDark }: PhotosProps) => {
  const [files, setFiles] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLockerClosed, setIsLockerClosed] = useState(true);
  const [modalContent, setModalContent] = useState<JSX.Element>(null!);
  const [downloadList, setDownloadList] = useState<string[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getFiles = async () => {
      const response = await fetch("https://yda-wedding.com/api/get_photos", {
        method: "GET",
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        setFiles(data.files);
      } else {
        setFiles([]);
      }
      setIsLoaded(true);
    };
    getFiles();
  }, []);

  const sendRequest = async (endpoint: string, photos: string[]) => {
    const filesArg =
      endpoint === "download"
        ? `?file=${photos
            .map((file) => encodeURIComponent(file))
            .join("&file=")}`
        : "";
    const url = `https://yda-wedding.com/api/${endpoint}${filesArg}`;

    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) return;

    if (photos.length > 1) {
      setDownloadList([]);
    }

    const fileName =
      response.headers
        .get("Content-Disposition")
        ?.match(/filename=(.+)/)?.[1] || "photos_26_9.zip";

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  };

  return (
    <>
      {isLockerClosed && (
        <div
          className={`w-[100vw] h-[100vh] ${
            isDark
              ? "bg-gradient-to-b from-gray-800 to-slate-900 text-gray-200"
              : "bg-gradient-to-b from-white to-red-100 text-black"
          }`}
        >
          {files.length > 0 ? (
            <div className="w-full h-full">
              <div
                className={`flex w-full justify-between items-center py-8 ${
                  isMobile
                    ? "px-[5vw] h-[10vh]"
                    : `sm:px-20 lg:px-40 xl:py-2 ${
                        isVertical ? " h-[3vh]" : "h-[6vh]"
                      }`
                } ${isDark ? "bg-gray-600" : "bg-light-header"}`}
              >
                <button onClick={() => setIsLockerClosed(false)}>
                  <img
                    src={`/header/logo-${isDark ? "dark" : "light"}.png`}
                    alt="logo"
                    width={"40px"}
                  />
                </button>
                <button
                  onClick={() => {
                    saveThemeCookie(!isDark);
                    setDark(!isDark);
                  }}
                  className={isMobile ? "" : "mr-3"}
                >
                  <img
                    src={
                      isDark
                        ? "/header/theme-dark.png"
                        : "/header/theme-light.png"
                    }
                    alt="theme"
                    width={"40px"}
                  />
                </button>
                <button
                  onClick={() => {
                    sendRequest(
                      downloadList.length > 0 ? "download" : "download_all",
                      downloadList,
                    );
                  }}
                >
                  <img
                    src={`/photos/download-all-${
                      isDark ? "dark" : "light"
                    }.png`}
                    alt="download-all"
                    width={"40px"}
                  />
                </button>
              </div>
              <div
                className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 
              xl:grid-cols-6 gap-4 p-10 overflow-y-auto ${
                isMobile ? "h-[90vh]" : isVertical ? "h-[97vh]" : "h-[93vh]"
              }`}
              >
                {files.map((name) => (
                  <div key={name} className="relative">
                    <img
                      src={`/photos/${name}`}
                      alt=""
                      className="w-full h-64 object-cover"
                      loading="lazy"
                      onClick={() => {
                        setModalContent(
                          <img
                            src={`/photos/${name}`}
                            alt=""
                            height={window.innerHeight * 0.7}
                            width={
                              isMobile && !isVertical
                                ? window.innerWidth * 0.7
                                : "auto"
                            }
                          />,
                        );
                        setIsModalOpen(true);
                      }}
                    />
                    <button
                      className={`absolute top-2 left-2 hover:bg-wine bg-gray-200 bg-opacity-30 backdrop-blur-md 
                      p-0.5 rounded-full`}
                      onClick={() => {
                        setDownloadList((prevList) =>
                          prevList.includes(name)
                            ? prevList.filter((item) => item !== name)
                            : [...prevList, name],
                        );
                      }}
                    >
                      <img
                        src={
                          downloadList.includes(name)
                            ? "/photos/added.png"
                            : "/photos/add.png"
                        }
                        alt="add to download list"
                        width={24}
                      />
                    </button>
                    <button
                      className={`absolute bottom-2 right-2 p-1 rounded-full 
                      hover:bg-wine bg-gray-500 bg-opacity-50 backdrop-blur-md 
                      }`}
                      onClick={() => sendRequest("download", [name])}
                    >
                      <img
                        src="/photos/download-image.png"
                        alt="download"
                        width={24}
                      />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex w-full h-full text-lg items-center justify-center">
              {isLoaded ? <p>Нет доступа к фото</p> : <></>}
            </div>
          )}
          <ModalWindow
            isOpen={isModalOpen}
            setOpen={setIsModalOpen}
            content={modalContent}
          />
        </div>
      )}
      {!isLockerClosed && (
        <Locker
          isClosed={isLockerClosed}
          isDark={isDark}
          setClosed={setIsLockerClosed}
        />
      )}
    </>
  );
};

export default Photos;
